import React from 'react'
import { useMediaQuery } from 'react-responsive'

const DesktopView = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1201 })
    return isDesktop && children;
}

export default DesktopView
